(() => {
  const popup = document.getElementById('popup');
  if (!popup) return;

  const inner = popup.querySelector('.popup-inner');
  const closeButtons = popup.querySelectorAll('[data-close="popup"], .popup-close');
  let lastFocused = null;

  function openPopup() {
    lastFocused = document.activeElement;
    popup.hidden = false;                 // mostrar (controla el flash)
    document.body.classList.add('body--no-scroll');
    // enfoque al diálogo
    setTimeout(() => inner?.focus(), 0);

    document.addEventListener('keydown', onKeydown);
    popup.addEventListener('click', onOverlayClick);
  }

  function closePopup() {
    popup.hidden = true;
    document.body.classList.remove('body--no-scroll');

    document.removeEventListener('keydown', onKeydown);
    popup.removeEventListener('click', onOverlayClick);

    // devuelve el foco al disparador
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape') closePopup();
  }

  function onOverlayClick(e) {
    // cierra si se hace click en el overlay (fuera de .popup-inner)
    if (e.target === popup) closePopup();
  }

  // Botones/badges internos de cierre
  closeButtons.forEach(b => b.addEventListener('click', closePopup));

  // Auto-vincula a botones/enlaces cuyo texto sea “Guía de tallas”
  const triggers = Array.from(document.querySelectorAll('a, button'))
    .filter(el => /gu[ií]a de tallas/i.test(el.textContent));

  triggers.forEach(el => {
    el.addEventListener('click', (ev) => {
      ev.preventDefault();
      openPopup();
    });
  });

  // EXPONE funciones para compatibilidad con HTML legacy (si hay onClick="openPopup()")
  window.openPopup = openPopup;
  window.closePopup = closePopup;
})();
